module.exports = __webpack_public_path__ + "img/edit-roster-blue-outline.2a12eba3.svg";